import { AnyObject } from 'utils/types';

export type EventEntity<
  EventsKind = string,
  Payload extends AnyObject = AnyObject
> = {
  kind: EventsKind;
  payload: Payload;
};

export type Subscriber<EventsKind, Payload extends AnyObject> = (
  event: EventEntity<EventsKind, Payload>
) => void;

export type Unsubscribe = VoidFunction;

class PubSub<Entity extends EventEntity> {
  // @ts-ignore
  private _subs: Record<
    Entity['kind'],
    Subscriber<Entity['kind'], Entity['payload']>[]
  > = {};

  subscribe(
    eventKind: Entity['kind'],
    sub: Subscriber<Entity['kind'], Entity['payload']>
  ): Unsubscribe {
    if (!Array.isArray(this._subs[eventKind])) {
      this._subs[eventKind] = [sub];
    } else {
      this._subs[eventKind].push(sub);
    }

    return () => {
      this._subs[eventKind] = this._subs[eventKind]?.filter(
        (item) => item !== sub
      );
    };
  }

  publish(event: EventEntity<Entity['kind'], Entity['payload']>): void {
    this._subs[event.kind]?.forEach((sub) => {
      sub(event);
    });
  }

  destroy() {
    // @ts-ignore
    this._subs = {};
  }
}

export default PubSub;
